import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import { profile } from "../data/content";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} sm={6}>
            <a href="#home" className="brand-text">Pedro<span>Pampolini</span></a>
          </Col>
          <Col xs={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a target="_blank" rel="noopener noreferrer" href={profile.linkedin} aria-label="LinkedIn"><img src={navIcon1} alt="" /></a>
              <a target="_blank" rel="noopener noreferrer" href={profile.github} aria-label="GitHub"><img src={navIcon2} alt="" /></a>
              <a target="_blank" rel="noopener noreferrer" href={profile.instagram} aria-label="Instagram"><img src={navIcon3} alt="" /></a>
            </div>
            <p>© {new Date().getFullYear()} {profile.name}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
